<template>
  <div class="card">
    <div class="toolbar">
      <select v-model="query.brand" @change="onBrandChange">
        <option value="">全部品牌</option>
        <option v-for="item in brandOptions" :key="item" :value="item">{{ item }}</option>
      </select>
      <select v-model="query.model_name" @change="onModelChange">
        <option value="">全部型号</option>
        <option v-for="item in modelOptions" :key="item" :value="item">{{ item }}</option>
      </select>
      <select v-model="query.capacity" @change="onCapacityChange">
        <option value="">全部容量</option>
        <option v-for="item in capacityOptions" :key="item" :value="item">{{ item }}</option>
      </select>
      <select v-model.number="query.tenor_months">
        <option value="">全部期数</option>
        <option v-for="item in tenorOptions" :key="item" :value="item">{{ item }}期</option>
      </select>
      <button @click="fetchData">查询</button>
      <button class="primary" @click="exportCsv">导出CSV</button>
    </div>

    <table>
      <thead>
        <tr>
          <th>品牌</th>
          <th>型号</th>
          <th>容量</th>
          <th>期数</th>
          <th class="group-rent">最低总租金</th>
          <th class="group-rent">总租金商家</th>
          <th class="group-all">最低总价</th>
          <th class="group-all">总价商家</th>
          <th class="group-down">最低首付</th>
          <th class="group-down">首付商家</th>
          <th>最新更新时间</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, idx) in list" :key="idx">
          <td>{{ row.brand }}</td>
          <td>{{ row.model_name }}</td>
          <td>{{ row.capacity || '-' }}</td>
          <td>{{ row.tenor_months }}</td>
          <td class="group-rent">{{ row.min_total_price }}</td>
          <td class="group-rent">{{ row.min_total_price_merchant }}</td>
          <td class="group-all">{{ row.min_all_price }}</td>
          <td class="group-all">{{ row.min_all_price_merchant }}</td>
          <td class="group-down">{{ row.min_down_payment }}</td>
          <td class="group-down">{{ row.min_down_payment_merchant }}</td>
          <td>{{ row.latest_updated_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { statsLowest, dictBrands, dictModels, dictCapacities, dictTenors } from '@/api/priceMonitor'

export default {
  name: 'LowestStats',
  data() {
    return {
      query: { brand: '', model_name: '', capacity: '', tenor_months: '' },
      list: [],
      brandOptions: [],
      modelOptions: [],
      allCapacities: [],
      capacityOptions: [],
      tenorOptions: []
    }
  },
  async created() {
    await this.loadBrands()
    await this.loadCapacities(true)
    await this.loadTenors()
    this.fetchData()
  },
  methods: {
    async loadBrands() {
      const res = await dictBrands({})
      if (res.code === 200) {
        this.brandOptions = (res.data && res.data.list) || []
      }
    },
    async loadModels() {
      const res = await dictModels({ brand: this.query.brand || '' })
      if (res.code === 200) {
        this.modelOptions = (res.data && res.data.list) || []
      } else {
        this.modelOptions = []
      }
    },
    async loadCapacities(isInit = false) {
      const res = await dictCapacities({ brand: this.query.brand || '', model_name: this.query.model_name || '' })
      if (res.code === 200) {
        const list = (res.data && res.data.list) || []
        if (isInit) {
          this.allCapacities = [...list]
        }
        this.capacityOptions = list.length ? list : [...this.allCapacities]
      } else {
        this.capacityOptions = [...this.allCapacities]
      }
    },
    async loadTenors() {
      const res = await dictTenors({
        brand: this.query.brand || '',
        model_name: this.query.model_name || '',
        capacity: this.query.capacity || ''
      })
      if (res.code === 200) {
        this.tenorOptions = (res.data && res.data.list) || []
      } else {
        this.tenorOptions = []
      }
      if (this.query.tenor_months && !this.tenorOptions.includes(Number(this.query.tenor_months))) {
        this.query.tenor_months = ''
      }
    },
    async onBrandChange() {
      this.query.model_name = ''
      this.query.capacity = ''
      this.query.tenor_months = ''
      this.modelOptions = []
      this.capacityOptions = []
      if (this.query.brand) {
        await this.loadModels()
      }
      await this.loadCapacities()
      await this.loadTenors()
    },
    async onModelChange() {
      this.query.capacity = ''
      this.query.tenor_months = ''
      this.capacityOptions = []
      await this.loadCapacities()
      await this.loadTenors()
    },
    async onCapacityChange() {
      this.query.tenor_months = ''
      await this.loadTenors()
    },
    async fetchData() {
      const res = await statsLowest(this.query)
      if (res.code === 200) {
        const data = res.data || {}
        this.list = data.list || []
      } else {
        alert(res.msg || '查询失败')
      }
    },
    exportCsv() {
      const headers = ['品牌', '型号', '容量', '期数', '最低总租金', '总租金商家', '最低总价', '总价商家', '最低首付', '首付商家', '最新更新时间']
      const lines = this.list.map(row =>
        [
          row.brand,
          row.model_name,
          row.capacity || '',
          row.tenor_months,
          row.min_total_price,
          row.min_total_price_merchant,
          row.min_all_price,
          row.min_all_price_merchant,
          row.min_down_payment,
          row.min_down_payment_merchant,
          row.latest_updated_at
        ].join(',')
      )
      const csv = [headers.join(','), ...lines].join('\n')
      const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `最低价看板_${Date.now()}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    }
  }
}
</script>

<style scoped>
.card { background: #fff; border-radius: 8px; padding: 16px; }
.toolbar { display: flex; gap: 10px; margin-bottom: 12px; }
select, button { height: 34px; padding: 0 10px; border: 1px solid #d1d5db; border-radius: 6px; }
button { cursor: pointer; background: #fff; }
button.primary { background: #2563eb; color: #fff; border-color: #2563eb; }
table { width: 100%; border-collapse: collapse; }
th, td { border: 1px solid #e5e7eb; padding: 8px; font-size: 13px; text-align: left; }
.group-rent { background: #eff6ff; color: #1e3a8a; }
.group-all { background: #f0fdf4; color: #166534; }
.group-down { background: #fff7ed; color: #9a3412; }
</style>
